import { type ReactNode } from "react";
import ParrainHeader from "./headers/ParrainHeader";
import DashboardFooter from "./DashboardFooter";

// Composant de mise en page spécifique pour le dashboard Parrain
function ParrainDashboardLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen">
      <ParrainHeader />
      <main className="flex-grow">{children}</main>
      <DashboardFooter />
    </div>
  );
}

export default ParrainDashboardLayout;
